import styled from "styled-components";

export default {
    "Wrapper": styled.div`
        height: 40px;
        display: flex;
        gap: 8px;

        & > input {
            width: 100%;
            ${({ theme }) => theme.font.extra_small};
            padding: 0 20px;
            border: 1px solid ${({ theme }) => theme.color.grey3};
            border-radius: 4px;
        }
    `
}